import Helper from "./Helper";

class Worldmap {
  constructor(config = {}) {
    const { idName, className } = config;

    this.idName = idName;
    this.className = className;

    const maps = Array.prototype.slice.call(document.querySelectorAll('.lc-worldmap'));
    // console.log(maps);

    maps.forEach(map => {
      const triggers = Array.prototype.slice.call(
        map.querySelectorAll(`path[id*="${this.idName}"]`)
      );

      // console.log(triggers);

      triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
          const triggerNum = trigger.id.replace(this.idName, "");
          const popup = map.querySelector(`.${className}${triggerNum}`);

          // Show the popup with fade-in effect
          Helper.addClass(popup, "is-visible");
          setTimeout(() => {
            Helper.addClass(popup, "fade-in");
          }, 300);

          // Add event listener for close button inside the popup
          const closeButton = popup.querySelector('.close-btn');
          const backdrop = popup.querySelector('.lc-worldmap__backdrop');

          const closePopup = () => {
            // Remove the visible and fade-in classes to hide the popup
            Helper.removeClass(popup, "is-visible");
            setTimeout(() => {
              Helper.removeClass(popup, "fade-in");
            }, 300);
          };

          if (closeButton) {
            closeButton.addEventListener('click', closePopup);
          }

          if (backdrop) {
            backdrop.addEventListener('click', closePopup);
          }
        });
      });
    });
  }
}

export default Worldmap;

